<form [formGroup]="searchForm" (keydown.enter)="$event.preventDefault()">
    <mat-toolbar [ngClass]="{'basemode': !focused, 'focused': focused}">
        <mat-toolbar-row>
            <div class="outsides logos" fxLayout="row"
                 fxLayoutAlign="space-between center"
                 fxLayoutAlign.lt-sm="start center"
            >
                <button *ngIf="!focused" mat-icon-button fxFlex="14" (click)="toggleMenu()">
                    <mat-icon>menu</mat-icon>
                </button>

                <button *ngIf="focused" mat-icon-button fxFlex="14" (click)="navigateBack()">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <div class="logo" (click)="navigateHome()">
                    <div *ngIf="focused" class="logo-icon-w-text bg-image-inv" alt="logo"></div>
                    <div *ngIf="!focused" class="logo-icon-w-text bg-image" alt="logo"></div>
                    <span class="sp">&nbsp;</span>
                </div>
            </div>

            <div class="centru fill-remaining-space">
                <div class="searchbl">
                    <div class="shicon">
                        <mat-icon color="primary">search</mat-icon>
                    </div>
                    <div class="sconl">
                        <input #searchTerm class="gc" formControlName="searchTerm" maxlength="250" (click)="clickSearch($event)" aria-label="Search" placeholder="{{placeholderText}}" aria-autocomplete="both" aria-haspopup="true" spellcheck="false" type="text" tabindex="0">
                    </div>
                </div>
            </div>

            <div class="outsides">

                <ng-container *ngIf="currentApplication?.piiLevel">
                    <a routerLink="/admin/applications/myapplication/edit"
                       matTooltip="Application Settings"
                       [matTooltipShowDelay]="500"
                       class="pii-shield-link"
                    >
                        <ngc-pii-shield-level-small-badge [piiShieldLevel]="currentApplication?.piiLevel"
                                                          [extraSmall]="false"
                                                          [isIcon]="false"
                                                          [medium]="true"
                        >
                        </ngc-pii-shield-level-small-badge>
                    </a>
                </ng-container>

                <ng-container *ngIf="focused; else helpMenuTemplate">
                    <div style="width:56px"></div>
                </ng-container>

                <ng-container *ngIf="vendorApplications && vendorApplications.length > 0 && currentApplication">
                    <ng-container *ngTemplateOutlet="appMenuTemplate"></ng-container>
                </ng-container>

                <ng-container *ngTemplateOutlet="userMenuTemplate"></ng-container>

            </div>
        </mat-toolbar-row>
    </mat-toolbar>

    <!--<mat-toolbar-row *ngIf="focused" class="sec-row">
        <div class="outsides logos" fxLayout="row" fxLayoutAlign="space-between center">&nbsp;</div>
        <div class="centru fill-remaining-space">
            <div class="tcb-cont" *hasRole="['APPLICATION_ADMIN', 'SERVICE_OPERATOR']">

                    <!--<div class="cb-distr" *ngIf="contextDistrict && contextDistrict?.districtName">
                        <mat-checkbox formControlName="searchInDistrict">Search in district '{{contextDistrict?.districtName}}'</mat-checkbox><mat-icon mat-icon-button class="reset-icon" (click)="resetContextDistrict()">close</mat-icon>
                    </div>-->

                    <!--<mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChangeClick($event)">
                        <mat-tab label="ALL"></mat-tab>
                        <mat-tab label="ACTIVE"></mat-tab>
                        <mat-tab label="PENDING APPROVAL"></mat-tab>
                        <mat-tab label="WITHOUT DATA SYNC"></mat-tab>
                    </mat-tab-group>-->
            <!--</div>-->
        <!--</div>-->
        <!--<div class="outsides">&nbsp;</div>-->
    <!--</mat-toolbar-row>-->
</form>

<ng-template #helpMenuTemplate>
    <button mat-icon-button
            *hasRole="['APPLICATION_ADMIN', 'INSTITUTIONAL_ADMIN', 'SERVICE_OPERATOR']"
            [matMenuTriggerFor]="helpMenu"
            class="help-button"
            style="margin-right: 16px"
    >
        <ng-container *ngTemplateOutlet="helpIcon"></ng-container>
    </button>

    <mat-menu #helpMenu="matMenu" xPosition="before" class="user-menu">
        <button mat-menu-item (click)="openHelpCenter()"
                [disabled]="!helpCenterAvailable"
        >
            <ng-container *ngTemplateOutlet="helpIcon"></ng-container> Help Center
        </button>

        <button mat-menu-item *ngIf="!!currentPageTourName"
                (click)="startCurrentPageTour()"
        >
            <mat-icon>play_arrow</mat-icon> Run Tutorial
        </button>

        <div mat-menu-item (click)="changeToursPermit(); $event.stopPropagation()"
             [disabled]="isToursPermissionSaving"
        >
            <mat-checkbox [checked]="toursAllowed"
                          [disabled]="isToursPermissionSaving"
                          style="font-size: 16px; vertical-align: middle"
            >
                <span style="font-size: 14px; margin-left: 16px">Tutorials</span>
            </mat-checkbox>
        </div>
    </mat-menu>
</ng-template>

<ng-template #userMenuTemplate>
    <button mat-button [matMenuTriggerFor]="userMenu"
            id="user-menu-button"
            class="user-button mr-4">
        <span fxLayout="row" fxLayoutAlign="center center">
            <span class="user-name-based-avatar">{{user?.fullName | slice:0:1 | uppercase}}</span>
            <img class="avatar" src="{{user?.profilePhoto || 'assets/images/avatars/profile.jpg'}}" alt="avatar">
            <span fxLayout="column"
                 fxLayoutAlign="center start"
                 fxHide fxShow.gt-sm
                 class="mr-12"
            >
                <span class="username">{{user?.fullName}}</span>
                <span class="orgname">{{user?.orgName}}</span>
            </span>
            <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
        </span>
    </button>

    <mat-menu #userMenu="matMenu" xPosition="before" class="user-menu-panel">
        <button mat-menu-item (click)="clickProfile()">
            <mat-icon>account_circle</mat-icon>
            <span>My Profile</span>
        </button>

        <button mat-menu-item id="logout-button" class="" (click)="clickLogout()">
            <mat-icon>exit_to_app</mat-icon>
            <span>Logout</span>
        </button>
    </mat-menu>
</ng-template>

<ng-template #appMenuTemplate>
    <button mat-button
            *hasRole="['APPLICATION_ADMIN', 'SERVICE_OPERATOR']"
            [matMenuTriggerFor]="appMenu"
            style="margin-right: 16px"
            class="app-menu-button"
    >
        <span fxLayout="row" fxLayoutAlign="space-between center">
            <span class="app-logo">
                <img *ngIf="currentApplication?.icon" src="{{currentApplication?.icon}}" alt="logo">
                <span *ngIf="!currentApplication?.icon">{{currentApplication?.name | slice:0:1 | uppercase}}</span>
            </span>
            <span fxHide fxShow.gt-md class="app-name">{{currentApplication?.name}}</span>
            <mat-icon class="s-16" fxHide fxShow.gt-sm>keyboard_arrow_down</mat-icon>
        </span>
    </button>

    <mat-menu #appMenu="matMenu" xPosition="before" class="user-menu">
        <button mat-menu-item
                *ngFor="let app of vendorApplications"
                [ngClass]="{'selected-app-item': (app?.guid === currentApplication?.guid) && (router?.url !== CREATE_APP_ROUTE)}"
                matTooltip="{{app?.name}}"
                [matTooltipShowDelay]="1500"
                (click)="clickApp(app)"
        >
            <img *ngIf="app?.icon" class="app-icon" src="{{app?.icon}}" alt="logo">
            <span *ngIf="!app?.icon" class="app-icon-unknown">{{app?.name | slice:0:1 | uppercase}}</span>
            <span>{{app?.name}}</span>
        </button>

        <button id="add-application-button"
                mat-menu-item
                matTooltip="Add Application"
                [matTooltipShowDelay]="1500"
                [ngClass]="{'selected-app-item': router?.url === CREATE_APP_ROUTE}"
                (click)="clickAddApp()"
        >
            <mat-icon class="app-icon">add</mat-icon>
            <span>Add Application</span>
        </button>
    </mat-menu>
</ng-template>

<ng-template #helpIcon>
    <mat-icon class="help">help</mat-icon>
    <mat-icon class="help-outline">help_outline</mat-icon>
</ng-template>
